import React from 'react';
import {View, Text, StyleSheet, TouchableOpacity} from 'react-native';
import {Color, globalFontStyle} from '../../../assets';
import QrCode from './QRCode';

const LinkQu = ({isQrCode, onPaidClick, amt, linqQData}) => {
  const [time, setTime] = React.useState(linqQData?.expiry);
  const [expired, setExpired] = React.useState(false);
  const timerRef = React.useRef(time);
  React.useEffect(() => {
    const timerId = setInterval(() => {
      timerRef.current -= 1;
      if (timerRef.current < 0) {
        setExpired(true);
        clearInterval(timerId);
      } else {
        setTime(timerRef.current);
      }
    }, 1000);
    return () => {
      clearInterval(timerId);
    };
  }, []);
  return (
    <View
      style={{
        paddingHorizontal: 35,
        paddingVertical: 10,
        alignItems: 'center',
      }}>
      <Text style={[globalFontStyle.appFontSubHeading, {marginBottom: 5}]}>
        {isQrCode ? 'Scan the QR Code & pay from your app' : 'Checkout'}
      </Text>
      <Text style={[globalFontStyle.appFontSubText, {marginBottom: 20}]}>
        Amount: {amt}
      </Text>
      {isQrCode ? (
        <QrCode paymentOptionList={linqQData} />
      ) : (
        <Text
          style={[
            globalFontStyle.appFontHeading,
            {textAlign: 'center', marginVertical: 20},
          ]}>
          We have sent you a notification in your application. Please complete
          the payment
        </Text>
      )}
      <Text style={[globalFontStyle.appFontSubText, {marginTop: 10}]}>
        Complete payment in
      </Text>
      <Text style={globalFontStyle.appFontHeading}>{time} seconds</Text>
      <TouchableOpacity style={styles.yellowBox} onPress={onPaidClick}>
        <Text
          style={[globalFontStyle.appFontSmallText, {color: Color.bgWhite}]}>
          I have paid
        </Text>
      </TouchableOpacity>

      <Text
        style={[
          globalFontStyle.appFontSmallText,
          {textAlign: 'center', marginTop: 20},
        ]}>
        Do not refresh and back after payment. It will approve automatically
        within 1 minute. Do not pay twice
      </Text>
    </View>
  );
};

export default LinkQu;

const styles = StyleSheet.create({
  yellowBox: {
    marginTop: 5,
    borderRadius: 5,

    paddingHorizontal: 14,
    paddingVertical: 6,

    backgroundColor: '#0A57FF',
  },
});
